var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 34,
    viewBox: "0 0 53 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2143 12.1997H0.29834L10.7652 33.6843H20.6811L10.2143 12.1997Z",
    fill: "#0B92D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5971 6.69141H20.6812L31.8825 33.6848H41.7985L30.5971 6.69141Z",
    fill: "#137BC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6812 6.69141H30.5972L20.6812 33.6848H10.7653L20.6812 6.69141Z",
    fill: "#0E763F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0278 22.0806L10.7651 33.6846H20.6811L15.0278 22.0806Z",
    fill: "#FFD100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7651 33.6846H20.6811L15.0278 22.0806L10.7651 33.6846Z",
    fill: "#FFD100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0836 0.814941H52.9995L41.6145 33.6845H31.6986L43.0836 0.814941Z",
    fill: "#E20613"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2935 20.4189L31.7823 33.4434L31.8824 33.6846H41.7983L41.6982 33.4434L36.2935 20.4189Z",
    fill: "#0E4B9C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6147 33.6846L41.6982 33.4434L36.2935 20.4189L31.7823 33.4434L31.6987 33.6846H41.6147Z",
    fill: "#0E4B9C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlogo);
export default __webpack_public_path__ + "static/media/iconlogo.80517d0ea5d8966ce448ed44c199a826.svg";
export { ForwardRef as ReactComponent };